import { RightImageColumn } from 'components/Layout/TwoColumns/RightImageColumn/RightImageColumn';
import React from 'react';

import classes from './TwoColumnsLayout.module.scss';

interface TwoColumnsLayoutProps {
    header?: React.ReactNode;
    leftColumn?: React.ReactNode;
    rightColumn?: React.ReactNode;
    rightColumnImage?: string;
    children?: React.ReactNode;
}

export const TwoColumnsLayout: React.FC<TwoColumnsLayoutProps> = props => {
    return (
        <div className={classes.root}>
            {props.header}

            <div className={classes.container}>
                {props.leftColumn}

                {props.rightColumn}

                {!props.rightColumn && props.rightColumnImage && (
                    <RightImageColumn image={props.rightColumnImage} />
                )}

                {props.children}
            </div>
        </div>
    );
};
